import { coverageRegions } from './data';

export default function ServiceCoverageContent() {
    return (
        <div>
            <h2 className="text-2xl font-bold leading-[1.3] tracking-[-0.5px] text-foreground sm:text-[28px] lg:text-[36px]">
                Service Coverage
            </h2>
            <p className="mt-3 text-xs leading-relaxed text-text-light sm:text-sm">
                Podus is growing across multiple regions, ensuring people and businesses can access reliable legal support wherever they are. Our services adapt to each country's legal environment — offering free, paid, or restricted features based on local regulations and community needs.
            </p>

            <div className="mt-8 space-y-6">
                {coverageRegions.map((region) => (
                    <div
                        key={region.country}
                        className="overflow-hidden rounded-2xl border border-border bg-white"
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between border-b border-border px-5 py-4 sm:px-6">
                            <div className="flex items-center gap-3">
                                <span className="text-2xl">{region.flag}</span>
                                <h3 className="text-base font-bold text-foreground sm:text-lg">{region.country}</h3>
                            </div>
                            <span
                                className={`rounded-full px-3 py-1 text-xs font-semibold ${
                                    region.status === 'active'
                                        ? 'bg-green-50 text-green-700'
                                        : 'bg-amber-50 text-amber-700'
                                }`}
                            >
                                {region.status === 'active' ? 'Active' : 'Expanding'}
                            </span>
                        </div>

                        {/* Body */}
                        <div className="px-5 py-4 sm:px-6">
                            <p className="text-sm leading-relaxed text-text-light">
                                {region.description}
                            </p>

                            <div className="mt-4">
                                <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-foreground/60">
                                    Available Services
                                </p>
                                <div className="flex flex-wrap gap-2">
                                    {region.services.map((service) => (
                                        <span
                                            key={service}
                                            className="rounded-lg bg-background px-3 py-1.5 text-xs font-medium text-foreground"
                                        >
                                            {service}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
